/* RESPONSIBLE TEAM: team-inbox */
import type AppService from 'embercom/services/app-service';
import Service, { inject as service } from '@ember/service';
import MurmurHash3 from 'imurmurhash';
import moment from 'moment-timezone';

export default class ActivityTrackingSamplingService extends Service {
  @service declare appService: AppService;

  SAMPLE_RATE = 0.01;

  get shouldSampleActivity() {
    return (
      this.appService.app?.hasDetailedActivityTracking ||
      (this.appService.app?.hasSampledActivityTracking &&
        this.adminHash() <= this.SAMPLE_RATE * (2 ** 32 - 1))
    );
  }

  adminHash() {
    // sample on a 48 hour period basis,
    // where the period starts always on an even numbered ISO ordinal date
    // https://en.wikipedia.org/wiki/ISO_8601#Ordinal_dates
    let evenDay = moment();
    evenDay.dayOfYear(evenDay.dayOfYear() - (evenDay.dayOfYear() % 2));
    let hashState = MurmurHash3(evenDay.toDate().toDateString());
    hashState.hash(this.appService.app?.currentAdmin?.id);
    return hashState.result();
  }
}
